import React, { useEffect, useState } from 'react';

import { Glyphicon } from 'react-bootstrap';
import styled from 'styled-components';
import { AxiosError } from 'axios';

import { getFHItems } from '../services/ActivitiesService';
import TopPanel from '../components/utils/TopPanel';
import FareharborItemsList from '../components/fareharborItems/FareharborItemsList';
import ActivityCreateModal from '../components/activities/ActivityModals/ActivityCreateModal/ActivityCreateModal';
import * as Service from '../services/ActivitiesService';
import * as PartiesService from '../services/PartiesService';
import BookingOptionsAppendForm from '../components/fareharborItems/BookingOptionsAppendForm';
import { Activity, ActivitySource, BookingOption } from '../types/Activity';
import { syncFHItems } from '../api/ActivitiesApi';
import { PartyType } from '../types/Party';

/* eslint-disable no-shadow */

const StyledLoaderWrapper = styled.div`
  text-align: center;
  position: absolute;
  left: 0;
  right: 0;
  top: 30%;
  margin: auto;
`;

const FareharborItems = () => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const [allTags, setAllTags] = useState([]);
  const [builtActivity, setBuiltActivity] = useState(null);
  const [buildBookingOptions, setBuiltBookingOptions] = useState(null);
  const [partyTypes, setPartyTypes] = useState<PartyType[]>([]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const fhItems = await getFHItems();
      const tags = await Service.getAllTags();
      const partyTypes = await PartiesService.listActivePartyTypes();
      setItems(fhItems);
      setAllTags(tags);
      setPartyTypes(partyTypes);
    } catch (e) {
      console.error(e);
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    } finally {
      setLoading(false);
    }
  };

  const onActivitySave = async (
    activity: Activity,
    bookingOptions: BookingOption[] = [],
    selectedActivity: Activity
  ) => {
    try {
      setLoading(true);
      const { id, ...restOfActivity } = activity;
      const {
        id: selectedActivityId,
        cancellationPolicy,
        description,
        pictures,
        popularity,
        tags = [],
        vendorId,
        vendorName,
      } = selectedActivity ?? {};
      if (selectedActivity) {
        await Service.updateActivity(selectedActivityId, {
          ...restOfActivity,
          bookingOptions,
          cancellationPolicy,
          description,
          pictures,
          popularity,
          tags,
          vendorId,
          vendorName,
        });
      } else {
        await Service.createActivity({
          ...activity,
          bookingOptions,
        });
      }
      setBuiltActivity(null);
    } catch (e) {
      console.error(e);
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    } finally {
      setLoading(false);
    }
  };

  const onVariantSave = async activityId => {
    try {
      setLoading(true);
      const activity = await Service.getById(activityId);
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      delete activity.id;
      const updated = {
        ...activity,
        bookingOptions: [
          ...activity.bookingOptions,
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          ...buildBookingOptions.variants,
        ],
        category: activity.category || '',
        type: activity.type || '',
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        sourceId: buildBookingOptions.sourceId,
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        source: buildBookingOptions.source,
      };
      await Service.updateActivity(activityId, updated);
      setBuiltBookingOptions(null);
    } catch (e) {
      console.error(e);
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    } finally {
      setLoading(false);
    }
  };

  const onSyncFareharborItems = async () => {
    setLoading(true);
    try {
      await syncFHItems();
      alert(
        'We are updating Fareharbor Items. Please check back in 5 minutes.'
      );
    } catch (e) {
      const error = e as AxiosError;
      alert(
        `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      {builtActivity && (
        <ActivityCreateModal
          isFareharbor={true}
          isOpen={builtActivity}
          closeModal={() => setBuiltActivity(null)}
          allTags={allTags}
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          createActivity={onActivitySave}
          existingSource={ActivitySource.fareharbor}
          data={builtActivity}
          showActivitySelector
          partyTypes={partyTypes}
        />
      )}
      {buildBookingOptions && (
        <BookingOptionsAppendForm
          closeModal={() => setBuiltBookingOptions(null)}
          onSave={onVariantSave}
        />
      )}
      <TopPanel>
        <h1 className='col-md-6 col-sm-4 col-xs-3'>
          <span className='fas fa-beer' /> Fareharbor Items
        </h1>
        <div className='page-actions'>
          <button
            type='button'
            onClick={onSyncFareharborItems}
            className='btn btn-primary pull-right'
          >
            Sync FH Items
          </button>
        </div>
      </TopPanel>
      {loading && (
        <StyledLoaderWrapper>
          <Glyphicon key={0} glyph='refresh' className='spinning' />
        </StyledLoaderWrapper>
      )}
      {items.length > 0 && (
        <div className='table-box tab-cont'>
          <FareharborItemsList items={items} />
        </div>
      )}
    </>
  );
};

export default FareharborItems;
